const normalizeName = (name) => String(name || "").trim().toLowerCase();

export const getCharacterData = (statisticData, additionalContentId) => {
  if (additionalContentId) return statisticData?.[additionalContentId] || {};
  return Object.entries(statisticData || {}).find(
    ([key, value]) => key !== "detail" && value && typeof value === "object" && !Array.isArray(value),
  )?.[1] || {};
};

export const getCompletionCounts = (statisticData, additionalContentId) => {
  const characterData = getCharacterData(statisticData, additionalContentId);
  let completedCharacters = 0;
  let completedIndicators = 0;

  Object.values(characterData).forEach((indicators) => {
    let characterIsComplete = Object.keys(indicators || {}).length > 0;

    Object.values(indicators || {}).forEach((students) => {
      const indicatorIsComplete =
        Array.isArray(students) && students.length > 0;

      if (indicatorIsComplete) {
        completedIndicators += 1;
      } else {
        characterIsComplete = false;
      }
    });

    if (characterIsComplete) {
      completedCharacters += 1;
    }
  });

  return { completedCharacters, completedIndicators };
};

export const buildStudentStatistic = (statisticData, studentName, additionalContentId) => {
  const characterData = getCharacterData(statisticData, additionalContentId);
  const normalizedStudentName = normalizeName(studentName);
  const karakter = Object.entries(characterData).map(
    ([characterName, indicators], characterIndex) => {
      const indikator = Object.entries(indicators || {}).map(
        ([indicatorName, students], indicatorIndex) => {
          const isChecked = Array.isArray(students)
            ? students.some((name) => normalizeName(name) === normalizedStudentName)
            : false;

          return {
            id: indicatorIndex + 1,
            text: indicatorName,
            isChecked,
            pengisianGuru: [],
          };
        },
      );

      return {
        id: characterIndex + 1,
        nama: characterName,
        indikatorTerisi: indikator.filter((item) => item.isChecked).length,
        totalIndikator: indikator.length,
        indikator,
        pengisianGuru: [],
      };
    },
  );

  const indikatorTerisi = karakter.reduce(
    (total, character) => total + character.indikatorTerisi,
    0,
  );

  return {
    name: studentName,
    isAnswered: indikatorTerisi > 0,
    karakterTerisi: karakter.filter((item) => item.indikatorTerisi > 0).length,
    totalKarakter: karakter.length,
    indikatorTerisi,
    totalIndikator: karakter.reduce(
      (total, character) => total + character.totalIndikator,
      0,
    ),
    karakter,
  };
};
